require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-update-مركز-معلومات-البنك-ينشر-دراسته-حول-فعالية-مشاورات-البنك.json") })
        }
      }, "path---ar-eg-update-مركز-معلومات-البنك-ينشر-دراسته-حول-فعالية-مشاورات-البنك");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-update-مركز-معلومات-البنك-ينشر-دراسته-حول-فعالية-مشاورات-البنك!./.cache/json/ar-eg-update-مركز-معلومات-البنك-ينشر-دراسته-حول-فعالية-مشاورات-البنك.json
// module id = 463
// module chunks = 231608221292675